import { render, staticRenderFns } from "./TradingCalculatorMenu.vue?vue&type=template&id=cf9f1f8a&scoped=true"
import script from "./TradingCalculatorMenu.vue?vue&type=script&lang=js"
export * from "./TradingCalculatorMenu.vue?vue&type=script&lang=js"
import style0 from "./TradingCalculatorMenu.vue?vue&type=style&index=0&id=cf9f1f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9f1f8a",
  null
  
)

export default component.exports